/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-extraneous-dependencies,
  max-len,
  react/jsx-no-undef
*/
import React from 'react';
import Fixed from 'signer/components/common/fixed';
import HeaderButton from 'signer/components/common/header-button';
import NavHeader from 'signer/components/common/nav-header';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import HeaderMenu from '../../../common/header-menu';
import { AttachmentWithIntl } from './components/attachment';
import './index.scss';

class SignatureRequestAttachment extends React.Component {

    state = {
      attachmentStatus: {},
    };

    // This component really shouldn't have such deep knowledge of where signer
    // requests are stored and how they work.
    get attachmentSlots() {
      // https://en.wikipedia.org/wiki/Law_of_Demeter
      return this.props.location.state.signatureRequest.data.signatureRequestData.attachment_slots;
    }

    numRequired = () => this.attachmentSlots.filter((slot) => (
      (slot.required && this.state.attachmentStatus[slot.id] !== 'ready')
    )).length;

    numUploading = () => this.attachmentSlots.filter((slot) => (
      this.state.attachmentStatus[slot.id] === 'uploading'
    )).length;

    isReady = () => (
      this.numRequired() === 0
        && this.numUploading() === 0
    );

    setAttachmentStatus = (id, status) => this.setState({
      attachmentStatus: {
        ...this.state.attachmentStatus,
        [id]: status,
      },
    });


    complete = () => {
      this.props.app.router.redirect('confirm');
    };

    render() {

      /**
         * Conditional elements for desktop (not used in mobile page)
         * */

      const showLogo = !this.props.app.isEmbedded() && !this.props.app.whitelabel;
      const HFLogo = showLogo ? (
        <span className="m-signature-request--header--logo">
          <Logo dark={true} {...this.props} showIfCustom={false} />
        </span>
      ) : null;

      const showHeaderMenu = (this.props.app.canDownload() || this.props.app.canDecline() || this.props.app.canCancel());
      let headMenu;
      if (showHeaderMenu) {
        headMenu = <HeaderMenu
          onMenuToggle={this.onHeaderMenuToggle}
          canDelegate={this.props.app.canDelegate()}
          {...this.props} />;
      }

      const attachments = this.attachmentSlots.map((attachment) => (
        <AttachmentWithIntl
          {...this.props}
          signatureRequest={this.props.signatureRequest}
          setAttachmentStatus={this.setAttachmentStatus.bind(this, attachment.id)}
          key={attachment.id}
          attachment={attachment} />
      ));

      const nextButton = this.isReady() ? (
        <HeaderButton data-qa-ref="next-btn" className={'m-signature-request--header-next-button whitelabel-primary-button'}
          onClick={this.complete} {...this.props}
        >
          <FormattedMessage
            id="signer.nav.nextMessage"
            description="button text in singer flow when clicked points to the next field to be filled by signer"
            defaultMessage="Next" />
          <i className="ion-ios-arrow-forward"></i>
        </HeaderButton>
      ) : '';

      return (
        <div className="m-signature-request">

          <Fixed {...this.props} absolute={true}>
            <NavHeader className="m-signature-request--header small" {...this.props}>
              <span className="m-signature-request--header-fields-left whitelabel-fields-left"
                style={{ visibility: this.numRequired() > 0 ? 'visible' : 'hidden', marginLeft: '40px' }}
              >
                <FormattedHTMLMessage
                  id="signer.nav.fieldsLeftMessage"
                  description="text in navbar of signer flow, informing signer the number of fields left to fill"
                  defaultMessage="REQ<span class='m-signature-request--header-required-field'>*</span> { fieldsLeft, plural, =1 { field } other { fields } } left <span class='m-signature-request--header-fields-left-count'>{fieldsLeft}</span>"
                  values={{
                    fieldsLeft: String(this.numRequired()),
                  }} />
              </span>
              <div className="m-signature-request--header-nav-right">
                {nextButton}
                <br />
              </div>
              {headMenu}
              {HFLogo}

            </NavHeader>


          </Fixed>
          <div className="signature-request-attachment__container">
            <div className="signature-request-attachment__container-inner">
              <h4 className="signature-request-attachment__container-title">
                <FormattedMessage
                  id="signer.attachment.title"
                  description="text in signer flow of attachment page, simply indicating it is a attachment page"
                  defaultMessage="Attachments" />
              </h4>
              <p className="signature-request-attachment__container-info" >
                <FormattedMessage
                  id="signer.attachment.info"
                  description="text in signer flow of attachment page, informing signer that sender has requested documents to be attached with the signature request"
                  defaultMessage="The sender has requested { attachmentLeft, number } { attachmentLeft, plural, =1 {attachment} other {attachments} }."
                  values={{ attachmentLeft: String(this.attachmentSlots.length) }} />
              </p>

              {attachments}
            </div>
          </div>

        </div>
      );
    }
}

export default SignatureRequestAttachment;
